<template>
  <div class="bookmarked_bok" :class="{ [curTheme]: true }" @click="onClick">
    <el-tooltip v-if="!isBookmarked" content="Добавить в избранные" placement="top">
      <button class="bok_btn bok_btn--add"></button>
    </el-tooltip>
    <el-tooltip v-else content="Убрать из избранных" placement="top">
      <button class="bok_btn bok_btn--remove"></button>
    </el-tooltip>
  </div>
</template>

<script>
export default {

  props: {
    isBookmarked: false,
  },

  methods: {

    onClick($e) {
      this.$emit('click', $e);
    },

  },

};
</script>

<style lang="scss">
.bookmarked_bok {
  .bok_btn {
    width: 28px;
    height: 28px;
    cursor: pointer;
    &.bok_btn--add {
      background: 0 0 no-repeat url(/static/grx/icons/fav-not-set.svg);
      &:hover {
        background-image: url(/static/grx/icons/fav-not-set-hover.svg);
      }
    }
    &.bok_btn--remove {
      background: 0 0 no-repeat url(/static/grx/icons/fav-set.svg);
      &:hover {
        background-image: url(/static/grx/icons/fav-set-hover.svg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookmarked.vue